import { render } from "./MbaStrategicAccountingandTaxation.vue?vue&type=template&id=147c5bdf"
import script from "./MbaStrategicAccountingandTaxation.vue?vue&type=script&lang=js"
export * from "./MbaStrategicAccountingandTaxation.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__